import { gql } from "lib/apolloClient";
import { userFragment } from "modules/CommonFragments";
export const userProfileDetailsFragment = {
  staffProfileDetails: gql`
    fragment staffProfileItem on Staff {
      ...userItem
      role
      linkedThirdPartyAccounts {
        id
        userName
        serviceType
        isConnected
      }
    }
    ${userFragment.basicUserDetails}
  `,
  studentProfileDetails: gql`
    fragment studentProfileItem on Student {
      ...userItem
      linkedThirdPartyAccounts {
        id
        userName
        serviceType
        isConnected
      }
    }
    ${userFragment.basicUserDetails}
  `,
};
